import { ILand } from "@/modules/pe-fest-module/data/interfaces"
import { useState } from "react"
import LandContent from "../components/LandContent"
import ClusterMenu from "./ClusterMenu"

interface IProps {
    items: ILand[]
    onClose: () => void
    onOpenLogin?: () => void
}
const PlaceCluster = (props:IProps) :JSX.Element => {
    const [current, setCurrent] = useState<ILand>(props.items[0] )
    
    return (
        <div className="w-100 h-100 d-flex">
            <ClusterMenu 
                items={props.items}
                onClick={setCurrent}
                current={current}
            />
            <div className="topos-dmap-dialog-content">
                <LandContent item={current as ILand} onClose={props.onClose} onOpenLogin={props.onOpenLogin} isNarrow />
            </div>
        </div>
    )
}

PlaceCluster.propTypes = {}

export default PlaceCluster